import { Seo } from "@/components/site/Seo";
import { PageHero } from "@/components/site/PageHero";
import { Reveal, SectionHeading } from "@/components/site/Reveal";
import { CtaBanner } from "@/components/site/CtaBanner";
import { WhyList } from "@/components/home/WhySnapshot";

const STEPS = [
  { t: "Get in touch", d: "Call, WhatsApp or send the quote form with a few details and photos if you have them." },
  { t: "Free quotation", d: "We'll talk through what you need and give you a clear quote at no cost." },
  { t: "We do the work", d: "We arrive as arranged and carry out the job carefully and tidily." },
  { t: "Enjoy the result", d: "We check everything with you before we leave, so you're happy with the finish." },
];

export default function WhyUs() {
  return (
    <>
      <Seo title="Why Choose Us | Property Maintenance Oxfordshire"
        description="5 years of experience, friendly and reliable service, free quotations and multiple services under one roof – property maintenance throughout Oxfordshire." />
      <PageHero testId="why-hero" eyebrow="Why choose us"
        lines={["Friendly, reliable help", "for Oxfordshire homes."]}
        intro="We keep things simple: turn up on time, do careful work and leave your home the way you'd want it." />
      <section className="bg-[var(--navy-deep)] py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-6 lg:px-10"><WhyList bg="bg-[var(--navy-deep)]" /></div>
      </section>
      <section className="bg-white py-20 md:py-28" data-testid="why-process">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <SectionHeading eyebrow="How it works" title="Four simple steps." className="mb-14" />
          <ol className="grid gap-5 md:grid-cols-2 lg:grid-cols-4">
            {STEPS.map((s, i) => (
              <li key={s.t}>
                <Reveal delay={i * 0.08} className="h-full rounded-[1.5rem] bg-[var(--grey)] p-8">
                  <span className="font-display text-5xl font-bold text-[var(--green)]">{i + 1}</span>
                  <h3 className="mt-6 font-display text-xl font-semibold text-[var(--navy)]">{s.t}</h3>
                  <p className="mt-3 text-[var(--body)] leading-relaxed">{s.d}</p>
                </Reveal>
              </li>
            ))}
          </ol>
        </div>
      </section>
      <CtaBanner />
    </>
  );
}
